import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const testimonials = {

		init: function() {
			this.cacheDOM();

			if (!this.$slider.length) {
				return;
			}

			this.initSlider();
		},

		cacheDOM: function() {
			this.$root = $('.js-testimonials');
			this.$slider = this.$root.find('.js-testimonials-slider');
			this.$sliderNavigation = this.$root.find('.js-testimonials-navigation');
		},

		initSlider: function() {
			this.$root.each((index, element) => {
				const $section = $(element);
				const $sectionSlider = $section.find('.js-testimonials-slider');
				const $sliderNavigation = $section.find('.js-testimonials-navigation');
				const $prevArrow = $section.find('.js-testimonials-arrow-prev');
				const $nextArrow = $section.find('.js-testimonials-arrow-next');
				const testimonialCardsCount = $sectionSlider.find('.testimonials__card').length;
				const isDesktopInfinite = testimonialCardsCount > 3;
				const isLargeBreakpointInfinite = testimonialCardsCount > 2;
				const isTabletInfinite = testimonialCardsCount > 2;
				const isMobileInfinite = testimonialCardsCount > 1;

				if (!$sectionSlider.length || !$sliderNavigation.length) {
					return;
				}

				sliders.initializeSlider($sliderNavigation, {
					arrows: false,
					dots: false,
					infinite: isLargeBreakpointInfinite,
					autoplay: false,
					focusOnSelect: true,
					slidesToShow: 3,
					slidesToScroll: 1,
					asNavFor: $sectionSlider,
					responsive: [
						{
							breakpoint: 1199,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 991,
							settings: {
								infinite: isLargeBreakpointInfinite,
								slidesToShow: 2,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 767,
							settings: {
								infinite: isLargeBreakpointInfinite,
								slidesToShow: 3,
								slidesToScroll: 1,
							},
						},
					],
				});

				sliders.initializeSlider($sectionSlider, {
					autoplay: false,
					infinite: isDesktopInfinite,
					arrows: false,
					dots: false,
					asNavFor: $sliderNavigation,
					slidesToShow: 3,
					slidesToScroll: 1,
					responsive: [
						{
							breakpoint: 1199,
							settings: {
								infinite: isLargeBreakpointInfinite,
								slidesToShow: 2,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 991,
							settings: {
								infinite: isTabletInfinite,
								slidesToShow: 2,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 767,
							settings: {
								infinite: isMobileInfinite,
								slidesToShow: 1,
								slidesToScroll: 1,
							},
						},
					],
				});

				$prevArrow.on('click', function() {
					$sectionSlider.slick('slickPrev');
				});

				$nextArrow.on('click', function() {
					$sectionSlider.slick('slickNext');
				});
			});
		},

	};

	testimonials.init();
});
